import type * as React from 'react';

// eslint-disable-next-line monorepo/forbidden-imports
import { PrescreenConsumer, SlideUpConsumer } from '@xing-com/braze';

const LandingPageContent = (): React.ReactElement => {
  return (
    <>
      <PrescreenConsumer />
      <SlideUpConsumer />
    </>
  );
};

export default LandingPageContent;
